class CheckoutHandler {
    checkbox: HTMLInputElement;
    constructor() {
        this.xInvoiceListeners();
        this.toggleXInvoiceFields();
    }
    xInvoiceListeners() {
        this.checkbox = document.querySelector('input#billing-sta-billing_x_invoice');
        if(!this.checkbox) return;
        this.checkbox?.addEventListener('change', () => {
            this.toggleXInvoiceFields();
        })
    }
    toggleXInvoiceFields() {
        if(!this.checkbox) return;
        const checked = this.checkbox?.checked;
        const lwId = document.querySelector('#billing-sta-billing_leitweg_id') as HTMLInputElement;
        const parent = lwId?.parentElement as HTMLElement;

        if (parent) {
            parent.style.display  = checked ? 'block' : 'none';
            // lwId.style.display = checked ? 'block' : 'none';
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new CheckoutHandler();
});